import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        perPageSelect: css`
            label {
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base};
                font-size: ${TYPOGRAPHY.size.small};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${COLORS.lightBlack};
                padding: 2px 15px 0 0;
            }
            > div[class^="FormInputWrapper"] {
                max-width: 65px;
            }
            select {
                height: 28px;
            }
            span {
                top: -3px !important;
                padding: 0 8px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                    `,
                    css`
                        width: auto;
                    `,
                    css`
                        width: auto;
                    `,
                    null,
                    null,
                ])}
        `,
        linkList: css`
            li {
                button {
                    width: 24px;
                    span {
                        font-style: normal;
                        font-weight: 400;
                        font-size: 15px;
                        line-height: 24px;
                        color: ${COLORS.dark};
                    }
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                    `,
                    css`
                        width: auto;
                    `,
                    css`
                        width: auto;
                    `,
                    null,
                    null,
                ])}
        `,
        currentButton: css`
            min-height: 24px;
            span {
                color: ${getColor("primary.contrast")} !important;
            }
        `,
        pagination: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 20px;
                        flex-wrap: wrap;
                    `,
                    css`
                        margin-top: 20px;
                        flex-wrap: nowrap;
                    `,
                    css`
                        margin-top: 20px;
                        flex-wrap: nowrap;
                    `,
                    null,
                    null,
                ])}
        `,
    },
};
